import { OpenXmlPart } from './openXmlPart';
import { RelationshipPart } from './relationshipPart';
import { SheetPart } from './sheetPart';
import type { XlsxFile } from './xlsxFile';

export class WorkbookPart extends OpenXmlPart {
  public readonly rels: RelationshipPart;
  public readonly sheets: SheetPart[] = [];

  constructor(filePath: string, originalXml: string, xlsxFile: XlsxFile) {
    super(filePath, originalXml, xlsxFile);

    const rels = RelationshipPart.fromFile(filePath, xlsxFile);
    if (!rels) {
      throw new Error('Workbook does not have a relationship file');
    }
    if (xlsxFile.workbook) {
      throw new Error('Workbook already exists');
    }

    xlsxFile.workbook = this;

    this.rels = rels;

    for (const element of this.dom.getElementsByTagName('sheet')) {
      const sheet = this.rels.getPartFromElement<SheetPart>(element);
      if (sheet) {
        this.sheets.push(sheet);
        sheet.name = element.getAttribute('name');
      }
    }
  }

  override init(): void {
    for (const sheet of this.sheets) {
      sheet.init();
    }
  }
}
